import React from "react"

import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import { SkuId } from "shared/hubrise/ids"
import ItemDeal from "shared/hubrise/items/ItemDeal"
import { IDeal } from "shared/hubrise/models"

const useItemDeal = (deal: IDeal) => {
  const { catalog } = useEditor()
  const { variantRef } = useCatalogNavigation()

  const itemDeal = React.useRef<ItemDeal>(new ItemDeal(catalog, deal)).current
  const [, rerender] = React.useReducer((x: number) => x + 1, 0)

  return {
    itemDealLines: itemDeal.dealLines,
    price: itemDeal.price(variantRef),
    setSkuId: (dealLineIndex: number, skuId: SkuId) => {
      itemDeal.setSkuId(dealLineIndex, skuId)
      rerender()
    },
    setOptionNames: (dealLineIndex: number, optionListName: string, optionNames: Array<string>) => {
      itemDeal.dealLines[dealLineIndex].setOptionNames(optionListName, optionNames)
      rerender()
    },
  }
}

export default useItemDeal
